import styled from 'styled-components';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  system,
} from 'styled-system';

export type BoxProps = LayoutProps &
  SpaceProps &
  FlexboxProps &
  ColorProps &
  BackgroundProps &
  ColorProps &
  BorderProps &
  ShadowProps &
  PositionProps & {
    gap?: string;
    cursor?: string;
    transform?: string;
  };

const gap = system({
  gap: {
    property: 'gap',
  },
});

const cursor = system({
  cursor: {
    property: 'cursor',
  },
});
const transform = system({
  transform: {
    property: 'transform',
  },
});

const Box = styled.div<BoxProps>`
  ${layout}
  ${space}
  ${flexbox}
  ${background}
  ${color}
  ${gap}
  ${border}
  ${position}
  ${cursor}
  ${transform}
  ${shadow}
`;

export { Box };
